import { render, staticRenderFns } from "./SaidaArsenal.vue?vue&type=template&id=0973b4ad&scoped=true&"
import script from "./SaidaArsenal.vue?vue&type=script&lang=js&"
export * from "./SaidaArsenal.vue?vue&type=script&lang=js&"
import style0 from "./SaidaArsenal.vue?vue&type=style&index=0&id=0973b4ad&lang=scss&scoped=true&"
import style1 from "./SaidaArsenal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0973b4ad",
  null
  
)

export default component.exports